import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const RussianRuble: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M6 11h8a4 4 0 0 0 0-8H9v18' }],
    ['path', { d: 'M6 15h8' }],
  ],
];

export default RussianRuble;
